import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/",
)({
  beforeLoad: ({ params: { tenantId } }) => {
    throw redirect({
      to: "/settings/system/tenants/$tenantId/users",
      params: { tenantId },
    })
  },
})
